import { createContext, useContext } from 'react';
export const PropertyDefinitionOverrideContext = /*#__PURE__*/createContext({});
export const PropertyDefinitionOverrideProvider = PropertyDefinitionOverrideContext.Provider;
export const usePropertyDefinitionOverride = () => {
  const {
    propertyDefinitionOverride
  } = useContext(PropertyDefinitionOverrideContext);
  return propertyDefinitionOverride;
};